export enum MessageSeverity {
    normal = "NORMAL",
    high = "HIGH",
    critical = "CRITICAL"
}
